import React from 'react';
import {Icon, Image, Button} from 'semantic-ui-react';
import classNames from 'classnames';

import constants from '@constants';
import {Props} from './types';
import paths from '@paths';

import './index.scss';

// pathに'disaster-notices'が含まれていればtrue
const isDisasterNoticePath = new RegExp(/^(?=.*disaster-notices).*$/);

const Main: React.FC<Props> = props => {
  return (
    <div className="a__side-bar">
      <Button
        onClick={() => props.history.push(paths.dashboard.main)}
        className="b__logo
      "
      >
        <Image src={constants.IMAGES.LOGO_WHITE_H} />
      </Button>
      <Button
        className={classNames('w__menu', {
          active: props.history.location.pathname === paths.dashboard.main,
        })}
        onClick={() => props.history.push(paths.dashboard.main)}
      >
        <Image src={constants.IMAGES.GRAPH} className="b__icon" />
        <div className="w__text">
          <span className="b__text">ダッシュボード</span>
        </div>
      </Button>
      <Button
        className={classNames('w__menu', {
          active: props.history.location.pathname.includes(paths.users.main),
        })}
        onClick={() => props.history.push(paths.users.main)}
      >
        <Image src={constants.IMAGES.ADMINISTRATOR} className="b__icon" />
        <div className="w__text">
          <span className="b__text">ユーザー</span>
        </div>
      </Button>
      <Button
        className={classNames('w__menu', {
          active: isDisasterNoticePath.test(props.history.location.pathname),
        })}
        onClick={() => props.history.push(paths.disasterNotices.main)}
      >
        <Image src={constants.IMAGES.ALERT} className="b__icon" />
        <div className="w__text">
          <span className="b__text">災害通知履歴</span>
        </div>
      </Button>
      <Button
        className={classNames('w__menu', {
          active: props.history.location.pathname === paths.send.main,
        })}
        onClick={() => props.history.push(paths.send.main)}
      >
        <Icon name="share square outline" className="b__icon send" />
        <div className="w__text">
          <span className="b__text">手動送信</span>
        </div>
      </Button>
      <Button
        className={classNames('w__menu', {
          active:
            props.history.location.pathname === paths.disasterSettings.main,
        })}
        onClick={() => props.history.push(paths.disasterSettings.main)}
      >
        <Image src={constants.IMAGES.SETTING} className="b__icon" />
        <div className="w__text">
          <span className="b__text">自動送信設定</span>
        </div>
      </Button>
    </div>
  );
};

export default Main;
